"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolPropertiesDetails = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * espool properties that are used by the individual applications detail requests.
 */
class EspoolPropertiesDetails {
}
exports.EspoolPropertiesDetails = EspoolPropertiesDetails;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
EspoolPropertiesDetails[_a] = [
    'Id',
    'EchainId',
    'ArtNr',
    'Bezeichnung',
    'BiegeradiusMin',
    'ExtraLeitungLength',
    'LeftKette',
    'LeitungDiameterMax',
    'LeitungLengthMin',
    'LinearExtension',
    'LinearKette',
    'RightKette',
    'SerieKuerzel',
    'TotalWeight',
    'TrommelDiameter',
];
EspoolPropertiesDetails[_b] = EspoolPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EIQ];
EspoolPropertiesDetails[_c] = EspoolPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EIQ];
EspoolPropertiesDetails[_d] = ['EchainId'];
//# sourceMappingURL=EspoolPropertiesDetails.js.map